// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3QXco","checkboxCol":"Table_checkboxCol__cE9zz","emailCol":"Table_emailCol__1hxcH","actionCol":"Table_actionCol__WJoLd"};